import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, photoUrl } from "../lib/api";
import { useLang } from "../lib/i18n";
import { distLabel } from "../lib/labels";
import { Reveal } from "../components/Reveal";
import Seo from "../components/Seo";

export default function Places() {
  const { lang } = useLang();
  const [places, setPlaces] = useState([]);
  useEffect(() => { api.get("/places").then((r) => setPlaces(r.data)).catch(() => {}); }, []);

  return (
    <div data-testid="places-page" style={{ background: "#F4F0E7", minHeight: "100vh" }}>
      <Seo path="/places" lang={lang} title={lang === "ru" ? "Места Алтая" : "Altai destinations"} description={lang === "ru" ? "Места Республики Алтай, которые становятся историями: горы, озёра, перевалы и археология." : "Destinations of the Altai Republic that become stories: mountains, lakes, passes and archaeology."} />
      <div className="max-w-[1600px] mx-auto px-5 md:px-10 pt-32 pb-24">
        <Reveal>
          <p className="eyebrow" style={{ color: "#A96818" }}>{lang === "ru" ? "Места" : "Destinations"}</p>
          <h1 className="display display-lg text-argali-obsidian mt-3">
            {lang === "ru" ? "Места, которые" : "Places that"}<br />
            <span className="text-argali-bronze">{lang === "ru" ? "становятся историями." : "become stories."}</span>
          </h1>
        </Reveal>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-14" data-testid="places-grid">
          {places.map((p, i) => (
            <Reveal key={p.id} delay={(i % 3) * 0.06}>
              <div className="group relative overflow-hidden aspect-[4/5]">
                <img src={photoUrl(p.photo_id)} alt={p.name_ru} loading="lazy" className="w-full h-full object-cover transition-transform duration-[1200ms] group-hover:scale-110" />
                <div className="absolute inset-0" style={{ background: "linear-gradient(180deg, rgba(17,17,15,0.1), rgba(17,17,15,0.8))" }} />
                <div className="absolute bottom-0 left-0 right-0 p-6">
                  <h3 className="font-serif text-2xl text-argali-ivory">{lang === "ru" ? p.name_ru : p.name_en}</h3>
                  <p className="text-argali-sandstone/70 text-xs mt-0.5">{lang === "ru" ? p.name_en : p.name_ru}</p>
                  <p className="eyebrow mt-3">{distLabel(p.district, lang)}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
        <div className="mt-12">
          <Link to="/map" className="btn-bronze">{lang === "ru" ? "Открыть карту" : "Open the map"}</Link>
        </div>
      </div>
    </div>
  );
}
